<template>
  <modal :title="$t('Zone.filter_zones')" @close-request="$emit('closeModal')" closable>

    <div class="modal-cont">

      <multi-select class="zone-select" :options="pickZones" :selected-options="newFilteredPickZones" @select="onPickZoneSelect"
        :placeholder="$t('Zone.modal.filter_zones.select_pick')" />

      <multi-select class="zone-select m-b" :options="dropZones" :selected-options="newFilteredDropZones" @select="onDropZoneSelect"
        :placeholder="$t('Zone.modal.filter_zones.select_drop')" />

    </div>

    <div class="btn-div">
      <button class="btn btn-blk btn-cnl" @click="clearFilter">{{ $t('Zone.modal.filter_zones.clear') }}</button>
      <button @click="confirm()" class="btn btn-kne-orange">{{ $t('Zone.modal.filter_zones.confirm') }}</button>
    </div>
  </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import RegularSelect from '../../basic-components/regularSelect.vue'
import RegularDatalist from '../../basic-components/regularDatalistDriver.vue'
import { MultiSelect } from 'vue-search-select'

export default {
  components: {
    Modal,
    RegularSelect,
    RegularDatalist,
    MultiSelect
  },
  data () {
    return {
      wallFileName: '',
      newFilteredPickZones: [],
      newFilteredDropZones: []
    }
  },
  props: {
    pickZones: Array,
    dropZones: Array,
    filteredPickZones: Array,
    filteredDropZones: Array
  },
  methods: {
    onPickZoneSelect (list) {
      this.newFilteredPickZones = list
    },
    onDropZoneSelect (list) {
      this.newFilteredDropZones = list
    },
    clearFilter () {
      this.newFilteredPickZones = []
      this.newFilteredDropZones = []
    },
    confirm () {
      this.$emit('filterZones', this.newFilteredPickZones.map(zone => zone.value), this.newFilteredDropZones.map(zone => zone.value))
    }
  },
  mounted () {
    this.newFilteredPickZones = this.pickZones.filter(zone => !this.filteredPickZones || this.filteredPickZones.includes(zone.value))
    this.newFilteredDropZones = this.dropZones.filter(zone => !this.filteredDropZones || this.filteredDropZones.includes(zone.value))
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    }
  }
}
</script>

<style scoped>
.btn-div {
  gap: 10px;
  width: 30%;
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  position: absolute;
  bottom: 0%;
  right: 0%;
  margin-bottom: 30px;
  margin-right: 30px;
}

.btn-div >.btn {
  margin-top: 8px;
}

.btn-blk {
  color: white;
  background-color: black;
}

.modal-cont {
  width: 95%;
  margin: 0 auto;
  margin-top: 20px;
}

.zone-select {
  margin-bottom: 15px;
}

.m-b {
  margin-bottom: 25%;
}
@media (max-width: 450px) {
  .m-b {
    margin-bottom: 65%;
  }
}
</style>
